<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData = $event"
        v-on:save="saveHandler"
      />
    </div>
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import PsnPayrollForm from "../../../components/payroll/psnpayroll/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": PsnPayrollForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      copyfromid: this.$route.params.copyfromid,
      search: this.$route.params.search,
      loading: false,
      pageTitle: this.$t('maintenanceforpayroll.createnewpersonpayrollinstruction'),
      pageTitleValue: "",
      formData: {
        staffid: null,
        startdate: null,
        enddate: null,
        paymodeid: null,
        paystatid: null,
        pcbcatid: null,
        childcount: null,
        taxid: null,
        isCompnypaytax: false,
        epfgroupid: null,
        epfeep: null,
        epferp: null,
        epfeeamt: null,
        epferamt: null,
        isfw: null,
        socsoid: null,
        epfveid: null,
        isEis: true,
        veeep: null,
        veerp: null,
        veeeamt: null,
        veeramt: null,
        baitulmalid: null,
        baieeamt: null,
        baieramt: null,
        // zakatamt: null,
        zakatp: null,
        isdynamic: false,
        stamp: 0,
        userid: this.$store.getters.userId,
      },

      currencyCode: "",
      paymodecode: "",
      paystatcode: "",

      pcbcats: [],
      pcbcatList: [],

      taxes: [],
      taxList: [],

      epfs: [],
      epfList: [],

      epfves: [],
      epfveList: [],

      socsos: [],
      socsoList: [],

      baitulmals: [],
      baitulmalList: [],

      payitems: [],
      payitemList: [],

      paymodes: [],
      paymodeList: [],

      paystats: [],
      paystatList: [],

      psns: [],
      psn0List: [],
      psn1List: [],
      psn2List: [],

      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    // Copy & Add: prefill everything from the source record except the dates
    async loadCopySource() {
      const vm = this;

      try {
        const res = await this.$store.dispatch('get', {url: "/psnpayroll/" + this.copyfromid});
        const rec = res.data.rec[0];

        for (const key of Object.keys(vm.formData)) {
          if (key in rec) vm.formData[key] = rec[key];
        }

        vm.formData.isCompnypaytax = rec.isCompnypaytax != "N";
        vm.formData.isEis = rec.isEis != "N";
        vm.formData.isdynamic = rec.isdynamic != "N";
        vm.formData.isfw = rec.isfw != "N";
        vm.formData.startdate = null;
        vm.formData.enddate = null;
        vm.formData.stamp = 0;
        vm.formData.userid = this.$store.getters.userId;
        vm.formData.lockstaff = true;
      } catch (err) {
        vm.isErr = true;
        vm.errMsg = err;
      }
    },

    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }
      if (this.formData.isCompnypaytax == false) {
        this.formData.isCompnypaytax = 0;
      } else {
        this.formData.isCompnypaytax = 1;
      }

      if (this.formData.isEis == false) {
        this.formData.isEis = 0;
      } else {
        this.formData.isEis = 1;
      }

      if (this.formData.isdynamic == false) {
        this.formData.isdynamic = 0;
      } else {
        this.formData.isdynamic = 1;
      }

      const payload = { ...vm.formData, copyfromid: vm.copyfromid || null };

      this.$store.dispatch('post', {url: "/psnpayroll/create", payload: payload})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = true;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "psnpayrolllist", params: { search: this.search } });
          }
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "psnpayrolllist" });
    },
  },

  async mounted() {
    if (!this.copyfromid) return;

    this.loading = true;
    try {
      await this.loadCopySource();
    } finally {
      this.loading = false;
    }
  },
};
</script>